<template>
  <section class="on-us">
    <LineText v-if="data.lineText !== undefined" :title="data.lineText"/>
    <div class="on-us__container c-container c-container--small">
      <h2
        class="on-us__title"
        data-anim="title"
      >
        {{ data.title }}
      </h2>
      <div class="on-us__text">
        <ul>
          <li
            v-for="(item, i) in data.list"
            :key="i"
          >
            <a :href="item.url" target="_blank">
              <img :src="`/img/app/${item.type}.svg`" :alt="`${item.type} icon`">
              <p>{{ item.text }}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import LineText from '@/components/LineText.vue';

export default {
  name: 'OnUs',

  components: {
    LineText,
  },

  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";

.on-us {
  &__container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-flow: row wrap;
  }

  &__title {
    width: 100%;
    flex: 0 0 100%;
    margin-bottom: 20px;

    @include mq(ipadP) {
      width: calc(40% - 40px);
      flex: 0 0 calc(40% - 40px);
      margin-bottom: 0;
    }
  }

  &__text {
    width: 100%;
    flex: 0 0 100%;

    @include mq(ipadP) {
      width: calc(60% - 40px);
      flex: 0 0 calc(60% - 40px);
    }

    & p {
      display: inline-block;
      margin-bottom: 20px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  ul li {
    display: inline-block;
    width: 40%;
    margin: 5% 5% 0 5%;

    @include mq(mobileL) {
      width: 20%;
      margin: 5% 5% 0 5%;
    }
  }

  ul li a,
  ul li a img,
  ul li a p {
    display: inline-block;
    position: relative;
    width: 100%;

    text-align: center;

    cursor: pointer;
  }

  ul li a img {
    width: 70%;
  }

  ul li a p {
    margin-top: 10px;
  }
}
</style>
